import {memo} from "react";

export const AddIcon = memo(({className, ...props}) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.75 11.25V6H11.25V11.25H6V12.75H11.25V18H12.75V12.75H18V11.25H12.75Z"
        fill="currentColor"
      />
    </svg>
  );
});

AddIcon.displayName = "AddIcon";
